import { useMxContext as useMxContextDefault } from '@soluto-private/mx-context-react';
import { useSetRecoilState } from 'recoil';
import { clientState, languageState } from './state';

export const useMxContext = () => {
  const context = useMxContextDefault();
  if(!context.client || context.client === ''){
    context.client = 'asurion';
  }

  useSetRecoilState(clientState)(context.client);
  useSetRecoilState(languageState)(context.language);

  return context;
};
